export function isFormGroupField(name) {
  return name.match(/.*\[.*\]\..*/g)?.length > 0;
}

export function splitFormGroupFieldName(name) {
  const [groupName, fieldIndex, fieldName] = name
    .split(/\[|\]|\./g)
    .filter((s) => s.length);
  return { groupName, fieldIndex, fieldName };
}
